module.exports = __webpack_public_path__ + "media/12_38.7f36da21.wav";